// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Employees-Staff-StaffList-__StaffList___2KZFi","table-header":"app-pages-Employees-Staff-StaffList-__StaffList___tQBWX","table-content-wrapper":"app-pages-Employees-Staff-StaffList-__StaffList___6nA5G","table-content":"app-pages-Employees-Staff-StaffList-__StaffList___3X04J","selected":"app-pages-Employees-Staff-StaffList-__StaffList___32-DB","outlet":"app-pages-Employees-Staff-StaffList-__StaffList___1rlN4","email-status":"app-pages-Employees-Staff-StaffList-__StaffList___N6ird","role":"app-pages-Employees-Staff-StaffList-__StaffList___3PebT"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Staff/StaffList/StaffList.css
// module id = 2343
// module chunks = 0